// providers/serviceTitan.ts
import * as Api from '@ViewModels';
import { provider, providerTag } from './helpers';

export const serviceTitanConfig = provider(Api.IntegrationProvider.ServiceTitan, {
	displayName: 'ServiceTitan',
	showConnections: false,

	configuration: {
		showOAuthClientCredentials: true,
		syncUserSource: 'allAdmins', // ServiceTitan doesn't use user connections
	},

	main: {
		writebacks: false,
	},

	keyFacts: {
		birthdayDisplay: false,
		dateFields: true,
	},

	tags: {
		coreTags: true,
		customFields: true,
		providerTags: [
			providerTag('DoNotMail', 'Do Not Mail'),
			providerTag('DoNotService', 'Do Not Service'),
			providerTag('CustomerType', 'Customer Type'),
			providerTag('BusinessUnit', 'Business Unit'),
			providerTag('MembershipStatus', 'Membership Status'),
			providerTag('MembershipFollowUpStatus', 'Membership Follow-Up Status'),
			providerTag('MembershipTypeName', 'Membership Type Name'),
			providerTag('ServiceAgreementName', 'Service Agreement Name'),
			providerTag('ServiceAgreementStatus', 'Service Agreement Status'),
		],
	},
});
